'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'comment-medical';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f7f5';
var svgPathData = 'M81.5 396.9l7.1-17.5-11.9-14.7C48.5 329.8 32 286.6 32 240 32 127 130.3 32 256 32s224 95 224 208-98.3 208-224 208c-32.6 0-63.4-6.4-91.2-18l-11.2-4.6-11.5 3.9-85.9 29.5 25.2-62zM0 512c14.8-5.1 65.6-22.6 152.5-52.4 31.6 13.1 66.7 20.4 103.5 20.4 141.4 0 256-107.5 256-240S397.4 0 256 0 0 107.5 0 240C0 294.4 19.3 344.6 51.8 384.8 24.7 451.5 7.4 493.9 0 512zM224 144l-16 0 0 48-48 0 0 96 48 0 0 48 96 0 0-48 48 0 0-96-48 0 0-48-80 0zm16 80l0-48 32 0 0 48 48 0 0 32-48 0 0 48-32 0 0-48-48 0 0-32 48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCommentMedical = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;